<script>
    import { location } from "svelte-spa-router";
    console.log($location);
    export let items;
</script>

<ul class="nav">
    {#each items as item}
        <li class="nav-item">
            <a
                class="nav-link {$location === `${item.path}`
                    ? 'active shadow'
                    : null}"
                href={`#${item.path}`}>{item.label}</a
            >
        </li>
    {/each}
</ul>

<style>
    .nav {
        justify-content: center;
        background: rgb(255, 240, 142);
        padding-top: 20px;
    }
    .nav-link {
        border: 1px solid #242424;
        color: #242424;
        border-radius: 7px;
        padding: 5px 15px;
        margin-right: 15px;
    }
    .nav-item a.active {
        background: #242424;
        color: #ffffff;
    }
    .nav-item a.active {
        color: 2px solid rgb(0 123 255 / 58%) !important;
    }
    .nav ul {
    }
    .nav li {
    }
</style>
